import React from 'react';

export const Eyebrow = ({children}) => (<subtitle>{children}</subtitle>)

